import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class PortfolioService {
  async getAllPortfolios() {
    try {
      const response = await axios.get(`${API}/portfolio/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching portfolios:', error);
      throw error;
    }
  }

  async getPortfolio(portfolioId) {
    try {
      const response = await axios.get(`${API}/portfolio/${portfolioId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching portfolio:', error);
      throw error;
    }
  }

  async getPortfolioMetrics(portfolioId) {
    try {
      const response = await axios.get(`${API}/portfolio/${portfolioId}/metrics`);
      return response.data;
    } catch (error) {
      console.error('Error fetching portfolio metrics:', error);
      throw error;
    }
  }

  async getPortfolioAllocation(portfolioId) {
    try {
      const response = await axios.get(`${API}/portfolio/${portfolioId}/allocation`);
      return response.data;
    } catch (error) {
      console.error('Error fetching portfolio allocation:', error);
      throw error;
    }
  }

  async createPortfolio(portfolioData) {
    try {
      const response = await axios.post(`${API}/portfolio/`, portfolioData);
      return response.data;
    } catch (error) {
      console.error('Error creating portfolio:', error);
      throw error;
    }
  }

  async addHolding(portfolioId, holdingData) {
    try {
      const response = await axios.post(`${API}/portfolio/${portfolioId}/holdings`, holdingData);
      return response.data;
    } catch (error) {
      console.error('Error adding holding:', error);
      throw error;
    }
  }

  async removeHolding(portfolioId, ticker) {
    try {
      const response = await axios.delete(`${API}/portfolio/${portfolioId}/holdings/${ticker}`);
      return response.data;
    } catch (error) {
      console.error('Error removing holding:', error);
      throw error;
    }
  }

  async initSamplePortfolio() {
    try {
      const response = await axios.post(`${API}/init-sample-portfolio`);
      return response.data;
    } catch (error) {
      console.error('Error initializing sample portfolio:', error);
      throw error;
    }
  }
}

export default new PortfolioService();
